import http_request from './http_request'
import config from 'config'
import agentTypes from 'helpers/enums/agentTypes'

function create(jwt, questionInitialData) {
	return http_request
		.post(`${config.slide_api_gateway}questions`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send(questionInitialData)
}

function get(activityUid, jwt) {
	return http_request
		.get(`${config.slide_api_gateway}questions/${activityUid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send()
}

function update(activityUid, questionData, jwt) {
	return http_request
		.put(`${config.slide_api_gateway}questions/${activityUid}`)
		.setAgentType(agentTypes.RAW)
		.withHeaders({Authorization: 'Bearer ' + jwt})
		.send(questionData)
}

export default {
	create,
	get,
	update,
}
